import React from "react";
import "./Modal.css";

// styles
import useStyles from "../login/styles";

const ModalMessageGeneric = ({ isOpen, closeModal, message }) => {
    var classes = useStyles();
    const handleContainerClick = (e) => e.stopPropagation();

    const onSubmit = async e => {
        e.preventDefault();
        closeModal();
    }

    return <article className={`modal ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-container" onClick={handleContainerClick}>
            <div style={{justify: 'center',
    alignItems: 'center', margin: "auto"}}>
            <p style={{fontSize: "20px"}}>{message}</p>
            </div>

            <div className={classes.formButtons}>
                <button
                    className={classes.enableButton}
                    onClick={onSubmit}
                >CERRAR</button>
            </div>
        </div>
    </article>
}

export default ModalMessageGeneric;